import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import parse from 'html-react-parser';
import Doc from "../../images/icons/doc.svg";
import { getLinkPrefix } from '../../utils/getLinkPrefix';

export const RepeatingPostItem = ({ post, searchResult, query, country_code, langKey }) => {
  const resultEndLengthPosition = 175;

  const visibleContentSection = (content = "") => {
    // To do
    // search for whole string if found, return substring around it.
    // If whole string not found, split the string and search for any findable keyword
    // if one keyword found, return substring around that section.
    const wholeStringIndex = content.toLocaleLowerCase().indexOf(query);

    if (wholeStringIndex > -1) {
      return contentSubstrings(content, wholeStringIndex);
    }

    // try to split the string and search for any findable keyword
    const keywords = query.split(' ');
    for (let i = 0; i < keywords.length; i++) {
      const keywordIndex = content.toLocaleLowerCase().indexOf(keywords[i]);
      if (keywordIndex > -1) {
        return contentSubstrings(content, keywordIndex);
      }
    }

    // default
    return content.substring(0, resultEndLengthPosition);
  }

  const contentSubstrings = (content = "", stringIndex = -1) => {
    let resultSection = "";

    if (stringIndex > 0) {
      resultSection = content.substring(stringIndex, stringIndex + resultEndLengthPosition);
    }
    else {
      resultSection = content.substring(0, resultEndLengthPosition);
    }
    return resultSection;
  }

  return (
    <div className={`result-item ${post.slug}`}>
      <Link to={getLinkPrefix(`${post.type ? post.type : 'articles'}`, post.slug)} language={langKey} title={post.title} className="searchItem">
        <div className="search-icon">
          <img src={Doc} alt="document icon" />
        </div>
        <div className="search-content">
          <h4 className="blue">
            {post.title}
          </h4>
          <p className="content-link">
            {searchResult ? parse(visibleContentSection(post.content.replace(/<[^>]+>/g, ''))) : parse(post.content.replace(/<[^>]+>/g, '').substring(0, resultEndLengthPosition))}
            ...
          </p>
        </div>
      </Link>
      <hr className="search-divider" />
    </div>
  )
}
